module.exports = __webpack_public_path__ + "static/media/generate-report.813b92f3.svg";